import { render } from "./MyDomainsV2.vue?vue&type=template&id=252fba81&scoped=true"
import script from "./MyDomainsV2.vue?vue&type=script&lang=ts"
export * from "./MyDomainsV2.vue?vue&type=script&lang=ts"

import "./MyDomainsV2.vue?vue&type=style&index=0&id=252fba81&scoped=true&lang=scss"
import "./MyDomainsV2.vue?vue&type=style&index=1&id=252fba81&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-252fba81"

export default script